import { render, staticRenderFns } from "./PaginationWidget.vue?vue&type=template&id=5cc580a4&"
import script from "./PaginationWidget.vue?vue&type=script&lang=ts&"
export * from "./PaginationWidget.vue?vue&type=script&lang=ts&"
import style0 from "./PaginationWidget.vue?vue&type=style&index=0&id=5cc580a4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports